import { render } from "./AppButton.vue?vue&type=template&id=bdfc937e"
import script from "./AppButton.vue?vue&type=script&lang=ts"
export * from "./AppButton.vue?vue&type=script&lang=ts"

import "./AppButton.vue?vue&type=style&index=0&id=bdfc937e&lang=css"
script.render = render

export default script